import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_ValuationFeeCheckUpdateStatus, BASEURL_POLYMER } from '../../utils/api';
import config from '../../config';

const isDevOrStgHost =
  document.location.origin === 'https://services3-dev.hdb.gov.sg' || document.location.origin === 'https://services3-stg.hdb.gov.sg';

interface QueryParams {
  application_uuid: string;
  singpass_token: string;
  uinfin: string;
}

interface UpdatePaymentStatus {
  message?: string;
  recommended_action?: string;
  ttc_num?: string;
  status: string;
}

export const getValuationFeeCheckUpdateStatusApi = createApi({
  reducerPath: 'getValuationFeeCheckUpdateStatusApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers) => {
      headers.set('Access-Control-Request-Method', 'GET');
      headers.set('X-Content-Type-Options', 'nosniff');
    },
  }),
  endpoints: (builder) => ({
    getValuationFeeCheckUpdateStatusApi: builder.query<UpdatePaymentStatus, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: 'GET',
        url: `${API_ValuationFeeCheckUpdateStatus}?application_uuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
          ...((config.isLocalhost || isDevOrStgHost) && queryParams.uinfin ? { uinfin: queryParams.uinfin } : {}),
        },
      }),
    }),
  }),
});

export const { useGetValuationFeeCheckUpdateStatusApiQuery } = getValuationFeeCheckUpdateStatusApi;
